import { render, staticRenderFns } from "./ProfileStat.vue?vue&type=template&id=472b93b9&"
import script from "./ProfileStat.vue?vue&type=script&lang=ts&"
export * from "./ProfileStat.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports